import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import userReducer from './reducers/userReducer';
import authReducer from './reducers/authReducer';
import schoolReducer from './reducers/schoolReducer';
import commonReducer from './reducers/commonReducer';
import moduleReducer from './reducers/moduleReducer';
import classesReducer from './reducers/classesReducer';
import gradeReducer from './reducers/gradeReducer';
import rootSaga from './sagas';
import studentPracticeReducer from './reducers/studentPracticeReducer';
import roleReducer from './reducers/roleReducer';
import groupPermissionsReducer from './reducers/groupPermissionsReducer';
import accountReducer from './reducers/accountReducer';
import studentExamReducer from './reducers/studentExamReducer'
import studentDashboardReducer from './reducers/studentDashboardReducer';
import studentManagementReducer from './reducers/studentManagementReducer';
import adminDashboardReducer from './reducers/adminDashboardReducer';
import adminReportingReducer from './reducers/reportingReducer';
import calendarReducer from './reducers/calendarReducer';
import meetingReducer from './reducers/meetingReducer';
import adminLearningMaterialReducer from './reducers/learningMaterialReducer';
import scoringReducer from './reducers/scoringReducer';
import distributionEvaluationReducer from './reducers/distributionEvaluationReducer';
import zoomReducer from './reducers/zoomReducer'
import aiConversationReducer from './reducers/aiConversationReducer'
import teacherDashboardReducer from './reducers/teacherDashboardReducer'
import partnerReducer from './reducers/partnerReducer';
import taskJobReducer from './reducers/taskJobReducer';
import { setForbiddenHandler } from '@libs/axios';
import { fetchMyPermissions } from './actions/authActions';
const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
    reducer: {
        auth: authReducer,
        user: userReducer,
        school: schoolReducer,
        common: commonReducer,
        module: moduleReducer,
        class: classesReducer,
        grade: gradeReducer,
        studentPractice: studentPracticeReducer,
        role: roleReducer,
        groupPermissions: groupPermissionsReducer,
        account: accountReducer,
        exam: studentExamReducer,
        studentDashboard: studentDashboardReducer,
        studentManagement: studentManagementReducer,
        adminDashboard: adminDashboardReducer,
        reporting: adminReportingReducer,
        calendar: calendarReducer,
        meeting: meetingReducer,
        learningMaterial: adminLearningMaterialReducer,
        scoring: scoringReducer,
        distributionEvaluation: distributionEvaluationReducer,
        zoom: zoomReducer,
        aiConversation: aiConversationReducer,
        teacherDashboard: teacherDashboardReducer,
        partner: partnerReducer,
        taskJob: taskJobReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: false,
            serializableCheck: false,
        }).concat(sagaMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
});

sagaMiddleware.run(rootSaga);

// API trả 403: quyền có thể vừa đổi trên ma trận -> tải lại /api/rbac/me/
setForbiddenHandler(() => store.dispatch(fetchMyPermissions()));

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type ResponseType = {
    headers: any;
    status: number;
    data: any;
}

export default store;

